import { AppData, Lightning, Log } from '@lightningjs/sdk'
import { Helper } from '../lib/helper';
import { Platform } from '../platforms/platform';
import { AppSetup } from '../lib/app-setup';
import { AppApiConfig } from '../lib/app-api-config';

export interface OptionsMenuItemTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

const controlsTextColor = 0xffffffff;
const controlsTextColorFocus = 0xffffffff;
const controlsTextColorSelected = 0xffff0000;
const controlsBGColorSelected = 0xffffffff;
const controlsBGColorFocus = 0xffff0000;
const controlsBGColor = 0xaa2c2c2c;


export default class OptionsMenuItem
  extends Lightning.Component<OptionsMenuItemTemplateSpec>
  implements Lightning.Component<OptionsMenuItemTemplateSpec>
{
  selected = false
  content = ''
  private _focusAnimation: Lightning.types.Animation | undefined = undefined
  static override _template(): Lightning.Component.Template<OptionsMenuItemTemplateSpec> {
    return {
      w: (w: any) => w,
      h: (h: any) => h,
      rect: true,
      color: 0x00000000,
      collision: true,
      shader: { type: Lightning.shaders.RoundedRectangle },
      Label: {
        x: 75,
        y: (h: any) => h / 2 + 5,
        mountY: 0.5,
        text: {
          text: "",
          fontSize: 28,
          fontFace: Helper.getFontFamily('Regular'),
          // letterSpacing: 0.82,
        },
      },
    }
  }

  // MenuItemWrapper: {
  //   x: 0,
  //   y: 0,
  //   Icon: {
  //     x: 0,
  //     y: 150,
  //     texture: '',
  //   },
  //   MenuItemName: {
  //     text: { text: '', fontSize: 28, fontFace: 'SFPro-Light', textColor: 0xffffffff },
  //   },
  // },


  override _handleEnter(target) {
    this.fireAncestors('$ItemSelected', target)
    return true
  }

  override _init() {
    if (this._focusAnimation) {
      this._focusAnimation.stop()
    }
  }

  _updateSelectedStatus() {
    const { appState } = AppData as AppSetup;
    const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
    const textfocuscolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textfocuscolor)

    const bgColor = this.selected ? controlsBGColorSelected : 0
    const textColor = this.selected ? controlsTextColorSelected : controlsTextColor
    this._focusAnimation = this.animation({
      duration: 0.3,
      actions: [
        // { p: 'scale', v: { 0: 1, 1: 1.1 } },
        { p: 'color', v: { 0: bgColor, 1: textfocuscolor } },
        { t: 'Label' , p: 'text.textColor', v: { 0: textColor, 1: controlsTextColorFocus } }
      ],
    });
    this._focusAnimation.start()
    this._focusAnimation.stop()
  }

  override _focus() {
    const { platform } = AppData as AppSetup
    if (this._focusAnimation) {
      this._focusAnimation.start()
    }
    platform?.textToSpeach(this.content)
  }        

  override _unfocus() {
    if (this._focusAnimation) {
      this._focusAnimation.stop()
    }
  }

  set itemSelected(itemSelected: any) {
    this.selected = itemSelected || false
    Log.info('OptionsMenuItem itemSelected: ', this.selected)
    this._updateSelectedStatus()
  }
  set item(itemInfo: any) {
    Log.info('OptionsMenuItem setItem: ', itemInfo)
    this.content = itemInfo.content
    this.tag('Label').text.text = itemInfo.content
  }

  _handleHover(target) {
   // console.log('OptionsMenuItem _handleHover : ', target, this.itemIndex)
    this.fireAncestors('$onIndexHover', {index: this.itemIndex})
  }
}
